/**
 * Notification types for consistent styling
 */
export type NotificationType = 'success' | 'error' | 'warning' | 'info';

/**
 * Interface for notification options
 */
export interface NotificationOptions {
  type: NotificationType;
  title: string;
  message?: string;
  duration?: number; // Duration in milliseconds, 0 for persistent
}

/**
 * Creates a custom event to trigger notifications in the app
 * This integrates with the existing toast system in App.tsx
 */
export function showNotification(options: NotificationOptions): void {
  const event = new CustomEvent('showAppNotification', {
    detail: options
  });
  
  window.dispatchEvent(event);
}

/**
 * Shows a success notification
 */
export function showSuccessNotification(title: string, message?: string, duration = 3000): void {
  showNotification({
    type: 'success',
    title,
    message,
    duration
  });
}

/**
 * Shows an error notification
 */
export function showErrorNotification(title: string, message?: string, duration = 5000): void {
  showNotification({
    type: 'error', 
    title,
    message,
    duration
  });
}

/**
 * Shows a warning notification
 */
export function showWarningNotification(title: string, message?: string, duration = 4000): void {
  showNotification({
    type: 'warning',
    title,
    message,
    duration
  });
}

/**
 * Shows an info notification
 */
export function showInfoNotification(title: string, message?: string, duration = 3000): void {
  showNotification({
    type: 'info',
    title,
    message,
    duration
  });
} 